/*
 * @Author: wangbaihe
 * @Date: 2023-07-21 11:41:58
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-07-08 17:20:53
 * @FilePath: \common-mediax\src\apis\MediaCloudJournal\Permission.js
 * @Description: MediaCloudJournalPermission
 */
import { createAPI } from '@common'

export default {
  // 获取单个期刊的所有操作详情（操作权限授权
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobmQfsn0bmm', 'GET', config),
  // 保存单个期刊的操作权限（操作权限授权
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobmQfsn0tbwf', 'POST', config),
  // 查询期刊根栏目
  getColumnRoots: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0dpmvno0spput', 'GET', config),
  // 查询期刊子栏目
  getColumnSubs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0dpmvno0tvct', 'GET', config)
}
